import React, { useState } from 'react';

import {
  Button,
  Dialog,
  DialogContent,
  Heading,
  Icon,
  Stack,
  Text,
  Textarea,
  useToast,
} from '@eluve/components';
import { templateBuilderStore } from '@eluve/smart-blocks';
import { useDialog } from '@eluve/utility-hooks';

import { GenerateOutputTemplate } from './GenerateOutputTemplate';

export const PrefillTemplateSection: React.FC = () => {
  const toast = useToast();
  const {
    isDialogOpen: isGenerateDialogOpen,
    toggleDialog: toggleGenerateDialog,
    setIsDialogOpen: setIsGenerateDialogOpen,
  } = useDialog();
  const {
    isDialogOpen: isImportDialogOpen,
    toggleDialog: toggleImportDialog,
    setIsDialogOpen: setIsImportDialogOpen,
  } = useDialog();

  const [importedJsonSchema, setImportedJsonSchema] = useState<string>('');

  const updateJsonSchema = () => {
    try {
      const parsedJson = JSON.parse(importedJsonSchema);

      // Validate that it has the expected structure for hydrateArtifact
      if (!parsedJson.artifactTemplate || !parsedJson.outputType) {
        toast.error(
          'Invalid JSON format. Expected exported template structure.',
        );
        return;
      }

      templateBuilderStore.send({
        type: 'hydrateArtifact',
        ...parsedJson,
        isImported: true,
      });

      toast.success('JSON Schema imported successfully');
      setImportedJsonSchema('');
      setIsImportDialogOpen(false);
    } catch {
      toast.error('Invalid JSON format. Please check your input.');
    }
  };

  return (
    <Stack gap={5} direction="horizontal">
      <Text inline className="text-nowrap">
        Pre-fill your template
      </Text>
      <Stack gap={2} direction="horizontal">
        <Button variant="outline" size="sm" onClick={toggleImportDialog}>
          <Icon name="FileInput" size="auto" />
          Import JSON
        </Button>
        <Button variant="outline" size="sm" onClick={toggleGenerateDialog}>
          <Icon name="Wand" size="auto" />
          Generate Template with AI
        </Button>

        {/* Import JSON Dialog */}
        <Dialog open={isImportDialogOpen} onOpenChange={setIsImportDialogOpen}>
          <DialogContent size="xl">
            <Stack gap={4}>
              <Heading size="2xl">Import JSON</Heading>
              <Textarea
                value={importedJsonSchema}
                onChange={(e) => setImportedJsonSchema(e.target.value)}
                className="mb-4 h-64 w-full font-mono"
                placeholder="Paste exported JSON here"
              />
              <Button onClick={updateJsonSchema}>
                <Icon name="FileInput" size="auto" />
                Import
              </Button>
            </Stack>
          </DialogContent>
        </Dialog>

        {/* Generate Template Dialog */}
        <Dialog
          open={isGenerateDialogOpen}
          onOpenChange={setIsGenerateDialogOpen}
        >
          <DialogContent size="xl">
            <GenerateOutputTemplate
              onTemplateGenerated={() => setIsGenerateDialogOpen(false)}
            />
          </DialogContent>
        </Dialog>
      </Stack>
    </Stack>
  );
};
